<div class="custom-page-column">
  <!-- Page 1 -->
  <div class="font-small pdf-page app-cb-eb-2025" id="cbeb2025">   
    <p class="font-large" style="text-align: center">
      <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY. </b>
    </p>

    <p class="font-large" style="text-align: center">
      <b>EQUIPMENT BREAKDOWN ENHANCEMENT ENDORSEMENT</b>
    </p>

    <p class="font-small">
      This endorsement modifies insurance provided under the following:
    </p>

    <p class="font-small">
        <b> BUILDING AND PERSONAL PROPERTY COVERAGE FORM CP 00 10<br />
            CONDOMINIUM ASSOCIATION COVERAGE FORM CP 00 17<br />
            CAUSES OF LOSS – BASIC FORM CP 10 10<br />
            CAUSES OF LOSS – BROAD FORM CP 10 20<br />
            CAUSES OF LOSS – SPECIAL FORM CP 10 30
        </b>
    </p>   
    
    <p class="font-small">
      Read the entire endorsement carefully to determine rights, duties and what is and is not covered.
    </p>

    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <ol type="A">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <p class="font-small" style="font-weight: normal;">
                  With respect to this endorsement only, Paragraph <b>d.</b> in <b>4.</b> Additional Coverages 
                  under Section <b>A.</b>  of the Building And Personal Property Coverage Form and Condominium 
                  Association Coverage Form is deleted and replaced with
                </p>
                <p class="font-small" style="font-weight: normal;">
                  <b>Pollutant Clean Up and Removal</b>
                </p>
                <p class="font-small" style="font-weight: normal;">
                  We will pay for the additional cost to repair or replace Covered Property because of 
                  contamination by a "pollutant". The most we will pay for loss or damage under this Additional 
                  Coverage is $250,000.
                </p>
                <p class="font-small" style="font-weight: normal;">
                  For this Additional Coverage, additional cost means those in excess of what would have been required 
                  to repair or replace the covered property, had no “pollutant” been involved.
                </p>
                <p class="font-small" style="font-weight: normal;">
                  This Additional Coverage does not apply to costs to test for, monitor or assess the existence, 
                  concentration or effects of “pollutants”. But we will pay for testing which is performed in the 
                  course of extracting the “pollutants” from the land or water.
                </p>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <p class = "font-small" style="font-weight: normal;">
                    With respect to this endorsement only, the following are added to <b>4.</b> Additional Coverages 
                    under Section <b>A.</b> of the Building And Personal Property Coverage Form and Condominium Association 
                    Coverage Form as a part of, and not in addition to, the limit per loss:
                </p>
                  <ol>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: normal;">
                        <b>Expediting Expenses</b>
                        <p class="font-small" style="font-weight: normal;">
                            When an “equipment breakdown” results in damage to Covered Property, we will pay the “reasonable extra cost” to:
                        </p>
                        <ol type="a" style="font-weight: bold;">
                          <li style="padding-bottom: 10px;">
                            <span style="font-weight: normal;">
                              Make temporary repairs;<br />                            
                            </span>
                          </li>
                          <li style="padding-bottom: 10px">
                            <span style="font-weight: normal;">
                              Expedite permanent repairs; and<br />                            
                            </span>
                          </li>
                          <li style="padding-bottom: 10px;">
                            <span style="font-weight: normal;">
                              Expedite permanent replacement<br />                            
                            </span>
                          </li>
                          
                        </ol>
                      </span>
                    </li>
                  </ol>
                </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ul style="list-style-type: none">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <ol start="2">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: bold;">
                        Refrigerant Contamination
                      </span>
                      <p class="font-small" style="font-weight: normal;">
                        We will pay for loss of “perishable goods” due to contamination from the release of 
                        refrigerant caused by an “equipment breakdown” to Covered Property.
                      </p>
                      <p class="font-small" style="font-weight: normal;">
                        The most we will pay for loss or damage under this Additional Coverage is $250,000.
                      </p>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: bold;">
                        Spoilage
                      </span>
                      <p class="font-small" style="font-weight: normal;">
                        We will pay for loss of “perishable goods” due to spoilage caused by an "equipment breakdown" to Covered Property.
                      </p>
                      <p class="font-small" style="font-weight: normal;">
                        However, we will not pay for any loss, damage, cost or expense directly caused by, 
                        contributed to by, resulting from or arising out of the following causes of loss                      
                      </p>
                      <p class="font-small" style="font-weight: normal;">
                        Fire, lightning, combustion explosion, windstorm or hail, weight of snow, ice or sleet, freezing, falling objects, 
                        smoke, aircraft or vehicles, riot or civil commotion, vandalism, sinkhole collapse, volcanic action, 
                        leakage from fire extinguishing equipment, water, water damage, earth movement or flood.                      
                      </p>
                      <p class="font-small" style="font-weight: normal;">
                        The most we will pay for loss or damage under this Additional Coverage is $250,000.                      
                      </p>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                      <span style="font-weight: bold;">
                        Temperature Fluctuation
                      </span>
                      <p class="font-small" style="font-weight: normal;">
                        We will pay for loss of “perishable goods” only caused by or resulting from any condition or event 
                        to Covered Property that can be resolved by calibrating, resetting, tightening, adjusting or 
                        cleaning.                      
                      </p>
                      <p class="font-small" style="font-weight: normal;">
                        However, we will not pay for loss of “perishable goods” as a result of resetting the power supply to the 
                        Covered Property containing the “perishable goods”.                      
                      </p>
                    </li>
                  </ol>               
                  
                  
                </span>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 2 -->
  <div class="font-small pdf-page app-cb-eb-2025">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            
                <ol start="4">
                <li style="list-style-type: none; padding-bottom: 10px;">
                  <p class="font-small">
                    The most we will pay for loss or damage under this Additional Coverage is $5,000 including any insurance provided for Business Income or Extra Expense.
                  </p>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>CFC Refrigerants</b><br />
                    <p class="font-small">
                        We will pay for the additional cost to repair or replace Covered Property because of the use or presence of a refrigerant containing CFC (chlorofluorocarbon) substances when an “equipment breakdown” results.
                    </p>
                    <p class="font-small">
                        For this Additional Coverage, additional cost means those in excess of what would have been required to repair or replace the covered property, had no CFC refrigerant been involved                     
                    </p>
                    <p class="font-small">
                        We also pay for additional loss as described under Spoilage Coverage provided by this endorsement or any insurance provided for Business Income, caused by the presence of a refrigerant containing CFC substances.                    
                    </p>
                    <p class="font-small">
                        We pay no more than the least of the following:                   
                    </p>
                    <ol type="a">
                        <li style=" font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                The cost to repair the damaged property and replace any lost CFC refrigerant;
                            </p>
                        </li>
                        <li style="font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                The cost to repair the damaged property, retrofit the system to accept a non-CFC refrigerant, and charge the system with a non-CFC refrigerant; or                            
                            </p>
                        </li>
                        <li style="font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                The cost to replace the system with one using a non-CFC refrigerant.                            
                            </p>
                        </li>
                    </ol>
                </span>
                </li>
               <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Computer Equipment</b><br />
                    <p class="font-small">
                        We will pay for loss or damage to your “computer equipment” caused by an “equipment breakdown”.
                    </p>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Data Restoration</b><br />
                    <p class="font-small">
                        We will pay for your reasonable and necessary cost to research, replace and restore the lost information on electronic 
                        media and records as a result of an “equipment breakdown”. 
                    </p>
                    <p class="font-small">
                        The most we will pay for loss or damage under this Additional Coverage is $100,000. 
                    </p>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Service Interruption</b><br />
                    <p class="font-small">
                        Any insurance provided for Business Income, Extra Expense, Spoilage or Data Restoration is extended 
                        to apply to your loss, damage or expense caused by an “equipment breakdown” to equipment that is owned by a utility, 
                        landlord or other supplier with whom you have a contract to supply you with any of the following services: 
                    </p>                    
                </span>
                </li>
                
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol type="A" start="2">
                <li style="list-style-type: none; padding-bottom: 10px;"> 

                <ol start="8">
                <li style="list-style-type: none; padding-bottom: 10px;">
                  <p class="font-small">
                        electrical power, waste disposal, air conditioning, refrigeration, heating, natural gas, compressed air, water, 
                        steam, internet access, telecommunications services, wide area networks or data transmission or “cloud computing”.
                         The equipment must meet the definition of “equipment breakdown” except that it is not Covered Property.                  
                  </p>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                    <span style="font-weight: normal;">
                    <b>Risk Improvement</b><br />
                    <p class="font-small">
                        If Covered Property suffers direct physical loss or damage due to an “equipment breakdown”, we will pay for the insured to improve the “power quality” of the electrical system or equipment at the loss location where the “equipment breakdown” occurred.                     
                    </p>
                    <p class="font-small">
                        We will pay the reasonable extra cost to improve “power quality” for the following electrical systems and/or equipment improvements:                    
                    </p>
                   
                    <ol type="a">
                        <li style=" font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                Installation of surge protection devices (SPD’s) which are installed at the loss location’s line disconnect, load disconnect, or on specific pieces of equipment and that are certified by Underwriter Laboratories (UL) or has an equivalent certification.
                            </p>
                            <p class="font-small" style="font-weight: normal;">
                                However, SPD’s do not include any SPD’s which are cord-connected surge strips, direct plug-in SPD’s or receptacle SPD’s;                            
                            </p>
                        </li>
                        <li style="font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                An upgrade and/or replacement of; electrical panels, switchgear and/or circuit breakers; or                            
                            </p>
                        </li>
                        <li style="font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                Electrical wire and wiring improvements which include installation of; flexible conduit, junction boxes and/or ground wiring.                            
                            </p>
                        </li>
                    </ol>
                    <p class="font-small">
                            We will not pay more than 10%, to a maximum limit of $10,000, of the loss amount paid. An invoice for implementation of this Additional Coverage must be sent to us within 180 days after the payment of the loss is received                    
                    </p>
                </span>
                </li>
               <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Off- Premises Coverage</b><br />
                    <p class="font-small">
                        We will pay for loss or damage to Covered Property resulting from a covered "equipment breakdown" while temporarily at a premises or location that is not a described premise.
                    </p>
                    <p class="font-small">
                        The most we will pay for loss or damage under this Additional Coverage is $25,000.                    
                    </p>
                </span>
                </li>             
                
                </ol>
                </li>
                <li style="font-weight: bold; padding-bottom: 10px;">
                    <p class="font-small" style="font-weight: normal;">
                        With respect to this endorsement only, the following are added to Section <b>F.</b> Additional Conditions of the 
                        Building And Personal Property Coverage Form and  Condominium Association Coverage Form:
                    </p>
                </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 3 -->
  <div class="font-small pdf-page app-cb-eb-2025">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            
                <ol start="1">
                <li style="font-weight: bold; padding-bottom: 10px;">
                    <span style="font-weight: normal;">
                        <b>Suspension</b><br />
                        <p class="font-small">
                            Whenever Covered Property is found to be in, or exposed to, a dangerous condition, any of our representatives may immediately suspend the insurance against loss to that Covered Property for the perils covered by this endorsement. Coverage can be suspended and possibly reinstated by delivering or mailing a written notice of suspension / coverage reinstatement to:                        
                        </p>
                        <ol type="a">
                        <li style=" font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                Your last known address; or
                            </p>
                        </li>
                        <li style="font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                The address where the property is located.                            
                            </p>
                        </li>                        
                        </ol>
                         <p class="font-small">
                            If we suspend your insurance, you will get a pro rata refund of premium. But the suspension will be effective even if we have not yet made or offered a refund.                        
                        </p>
                  </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Jurisdictional Inspections</b><br />
                    <p class="font-small">
                        If any Covered Property under this endorsement requires inspection to comply with state or municipal boiler and pressure vessel regulations, we agree to perform such inspection on your behalf. We do not warrant that conditions are safe or healthful.                    
                    </p>
                    
                </span>
                </li>
               <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Environmental, Safety and Efficiency Improvements</b><br />
                    <p class="font-small">
                        If Covered Property requires replacement due to an “equipment breakdown”, we will pay your additional cost to replace with equipment that is better for the environment, safer, or more energy efficient than the equipment being replaced.
                    </p>
                    <p class="font-small">
                        However, we will not pay more than 150% of what the cost would have been to repair or replace with like kind and quality. This Condition does not apply to any property to which Actual Cash Value applies.                    
                    </p>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                            <span style="font-weight: normal;">
                    <b>Green Environmental and Efficiency Improvements</b><br />
                    <p class="font-small">
                        If Covered Property requires repair or replacement due to an “equipment breakdown”, we will pay: 
                    </p>
                    <ol type="a">
                        <li style=" font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                The lesser of the reasonable and necessary additional cost incurred by the insured to repair or replace physically 
                                damaged Covered Property with equipment of like kind and quality which qualifies as “green”. Like kind and quality includes 
                                similar size and capacity.
                            </p>
                        </li>                                            
                        </ol>
                </span>
                </li>               
                
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol type="A" start="3">
                <li style="list-style-type: none; padding-bottom: 10px;">
                <ol type="1" start="4">
                    <li style="list-style-type: none; padding-bottom: 10px;"> 
                    <ol type="a" start="2">
                    <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                                The additional reasonable and necessary fees incurred by the insured for an accredited professional certified by a “green authority” to participate in the repair or replacement of physically damaged Covered Property as “green”.                  
                        </p>
                        </li>
                        <li style="font-weight: bold;" >
                        <p class="font-small" style="font-weight: normal;">
                                The additional reasonable and necessary cost incurred by the insured for certification or recertification of the repaired or replaced Covered Property as “green”.                        
                        </p>
                        </li>
                        <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                                The additional reasonable and necessary cost incurred by the insured for “green” in the removal, disposal or recycling of damaged Covered Property.                        
                        </p>
                        </li>
                        <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                                The Business Income loss during the additional time required for repair or replacement of Covered Property, consistent with “green”, in the coverages above.                        
                        </p>
                    </li>                
                           
                    
                    </ol>
                    <p class="font-small">
                        We will not pay more than 150%, to a maximum limit of $100,000, of what the cost would have been to repair or replace with equipment of like kind and quality inclusive of fees, costs, and any business interruption loss incurred as stated above.                        </p>
                    </li>
                    <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                            <b>Green Environmental and Efficiency Improvements</b> does not cover any of the following:
                        </p>
                        <ol type="a">
                    <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                            Covered Property does not include stock, raw materials, finished goods, “production machinery”, merchandise, electronic data processing equipment not used in the functional support of the real property, process water, molds and dies, property in the open, property of others for which the insured is legally liable, or personal property of others.                        
                        </p>
                        </li>
                        <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                            Any loss adjusted on any valuation basis other than a repair or replacement basis as per the Valuation section of this policy.                        
                        </p>
                        </li>
                        <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                            Any loss covered under any other section of this policy.                        
                        </p>
                        </li>
                        <li style="font-weight: bold;">
                        <p class="font-small" style="font-weight: normal;">
                            Any cost incurred due to any law or ordinance with which the insured was legally obligated to comply prior to the time of the “equipment breakdown”.                        
                        </p>
                    </li> 
                    </ol>                    
                    </li>
                     
                </ol>
                
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, the following are added to Section <b>H.</b> Definitions of the Building And Personal Property Coverage Form and Condominium Association Coverage Form:
                        </p>
                                        
                    </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 4 -->
  <div class="font-small pdf-page app-cb-eb-2025">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
                  <ol start="1">
                <li style="font-weight: bold;">
                    <span style="font-weight: normal;">
                        <p class="font-small">
                            “Cloud computing” means on-demand network access to a shared pool of computing resources via networks, servers, storage, applications and services provided by an organization with whom you have a contract with using the following service models: Software as a Service (SaaS), Platform as a Service (PaaS) and Infrastructure as a Service (IaaS) on the following deployment models: public cloud, community cloud, hybrid cloud and private cloud.                        
                        </p>
                  </span>
                </li>
                <li style=" font-weight: bold;">
                            <span style="font-weight: normal;">
                    <p class="font-small">
                        “Computer equipment” means Covered Property that is electronic computer or other data processing equipment, including peripherals used in conjunction with such equipment and electronic media and records.                    
                    </p>
                    
                </span>
                </li>
               <li style="font-weight: bold;">
                            <span style="font-weight: normal;">
                    <p class="font-small">
                        “Electronic equipment” means devices which operate using many small electrical parts such as, but not limited to, microchips, transistors or circuits.                    
                    </p>
                </span>
                </li>
                 <li style="font-weight: bold;">
                            <span style="font-weight: normal;">
                    <p class="font-small">
                        “Electronic equipment deficiency” means the quality or condition inside of “electronic equipment” which renders this equipment unexpectedly inoperable, and which is operable again once a piece of “electronic equipment” has been replaced.                    
                    </p>
                    <p class="font-small">
                        However, “electronic equipment deficiency” will not include replacement of “electronic equipment” for any condition that could have been resolved without replacement of the “electronic equipment” including but not limited to “computer equipment” maintenance or the reinstallation or incompatibility of software.                    
                    </p>
                </span>
                </li>
                <li style="font-weight: bold;">
                            <span style="font-weight: normal;">
                    <p class="font-small">
                        “Equipment breakdown” as used herein means:                    
                    </p>
                    <ol type="a">
                        <li style=" font-weight: bold;">
                            <p class="font-small" style="font-weight: normal;">
                                Physical loss or damage both originating within:
                            </p>
                            <ul style="list-style-type: none; padding-left: 0px">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(1) </b>Boilers, fired or unfired pressure vessels, vacuum vessels, and pressure piping, all normally subject to vacuum or internal pressure other than static pressure of contents, excluding:
                                    </span>
                                    <ul style="list-style-type: none; padding-left: 25px">
                                         <li style="padding-bottom: 10px; font-weight: bold; padding-top: 10px;">
                                            <span style="font-weight: normal;"><b>(a) </b>Waste disposal piping;
                                            </span>
                                         </li>
                                         <li style="padding-bottom: 10px; font-weight: bold;">
                                            <span style="font-weight: normal;"><b>(b) </b>Any piping forming part of a fire protective system;
                                            </span>
                                         </li>
                                         <li style="padding-bottom: 10px; font-weight: bold;">
                                            <span style="font-weight: normal;"><b>(c) </b>Furnaces; and
                                            </span>
                                         </li>
                                         <li style="padding-bottom: 10px; font-weight: bold;">
                                            <span style="font-weight: normal;"><b>(d) </b>Any water piping other than:
                                            </span>
                                            <ul style="list-style-type: none; padding-left: 25px">
                                                    <li style="padding-bottom: 10px; font-weight: bold; padding-top: 10px;">
                                                        <span style="font-weight: normal;"><b>(i) </b>Boiler feed water piping between the feed pump and the boiler;
                                                        </span>
                                                    </li>                                                   
                                            </ul>
                                         </li>
                                    </ul>
                                </li>
                                
                            </ul>
                        </li>                                            
                        </ol>
                </span>
                </li>               
                
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol type="a" start="1">
                <li style="list-style-type: none; padding-bottom: 10px;">
                    <ul style="list-style-type: none; padding-left: 0px">
                    <li style="list-style-type: none; padding-bottom: 10px;"> 
                        <ul style="list-style-type: none; padding-left: 25px">
                        <li style="padding-bottom: 10px; font-weight: bold; padding-top: 10px;">
                                            <span style="font-weight: normal;"><b>(ii) </b>Boiler condensate return piping; or
                                            </span>
                                         </li>
                                         <li style="padding-bottom: 10px; font-weight: bold;">
                                            <span style="font-weight: normal;"><b>(iii) </b>Water piping forming part of a refrigerating or air conditioning system used for cooling, humidifying or space heating purposes.
                                            </span>
                                         </li>
                         </ul>
                   
                    </li>
                   <li style="padding-bottom: 10px; font-weight: bold;">
                                            <span style="font-weight: normal;"><b>(2) </b> All mechanical, electrical, fiber optic equipment or “electronic equipment”; and
                                            </span>
                                         </li>
                     
                </ul>
                
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
                        <p class="font-small" style="font-weight: normal;">
                            Caused by, resulting from, or consisting of:
                        </p>
                        <ul style="list-style-type: none; padding-left: 0px">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(1) </b>Mechanical breakdown
                                    </span>
                                </li>
                                 <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(2) </b>Electrical or electronic breakdown and “electronic equipment deficiency”; or
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(3) </b>Rupture, bursting, bulging, implosion, or steam explosion.
                                    </span>
                                </li>
                        </ul>
                        <p class="font-small" style="font-weight: normal;">
                            However, “equipment breakdown” will not mean:                        
                        </p>                
                    </li>
            </ol>
            <ol type="a">
                <li style="font-weight: bold; padding-bottom: 10px;">
                        <p class="font-small" style="font-weight: normal;">
                            Physical loss or damage caused by or resulting from any of the following; however, if an “equipment breakdown” not otherwise excluded results, then we will pay for such resulting damage:                        
                        </p>
                        <ul style="list-style-type: none; padding-left: 0px">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(1) </b>Wear and tear;
                                    </span>
                                </li>
                                 <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(2) </b>Rust or other corrosion, decay, deterioration, hidden or latent defect, mold or any other quality in property that causes it to damage or destroy itself;
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(3) </b>Smog;
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(4) </b>Settling, cracking, shrinking or expansion;
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(5) </b>Nesting or infestation, or discharge or release of waste products or secretions, by birds, rodents or other animals;
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(6) </b>Any accident, loss, damage, cost, claim, or expense, whether preventative, remedial, or otherwise, directly or indirectly arising out of or relating to the recognition, interpretation, calculation, comparison, differentiation, sequencing, or processing of data by any computer system including any hardware, programs or software; or
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(7) </b>Scratching and marring.
                                    </span>
                                </li>
                        </ul>
                </li>
                <li style="font-weight: bold; padding-bottom: 10px;">
                    <p class="font-small" style="font-weight: normal;">
                            Loss, damage, cost or expense directly caused by, contributed to by, resulting from or arising out of the following causes of loss:                     
                    </p>
                     <p class="font-small" style="font-weight: normal;">
                            Fire, lightning, combustion explosion, windstorm or hail, weight of snow, ice or sleet, freezing, falling objects, smoke,                     
                    </p>
                </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 5 -->
  <div class="font-small pdf-page app-cb-eb-2025">
    <table>
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
             <ol type="A" start="4">
                <li style="list-style-type: none; padding-bottom: 10px;">
                    <ol type="1" start="5">
                    <li style="list-style-type: none; padding-bottom: 10px;"> 
                        <ul style="list-style-type: none; padding-left: 25px">
                            <li style="padding-bottom: 10px; font-weight: bold; padding-top: 10px;">
                                <span style="font-weight: normal;">aircraft or vehicles, riot or civil commotion, vandalism, sinkhole collapse, volcanic action, leakage from fire extinguishing equipment, water, water damage, earth movement or flood.
                                </span>
                            </li>
                                         
                        </ul>                   
                    </li>
                   <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">“Green” means products, materials, methods and processes certified by a “green authority” that conserve natural resources, reduce energy or water consumption, avoid toxic or other polluting emissions or otherwise minimize environmental impact.
                        </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">“Green authority” means an authority on “green” buildings, products, materials, methods or processes certified and accepted by Leadership in Energy and Environmental Design (LEED®) Green Building initiative Green Globes®, Energy Star® Rating System or any other recognized “green” rating system.
                        </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">"Perishable goods" means stock preserved and maintained under controlled conditions and susceptible to loss or damage if the controlled conditions change.
                        </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">“Power quality” means the conditions that allow electrical systems or equipment to operate as intended by limiting voltage fluctuations and other power influences that would adversely affect the operational performance and/or reduce the reliability, or the lifespan of the electrical system.
                        </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">“Production machinery” means any machine which processes, forms, shapes, or transports raw materials, materials in process, waste materials or finished products.
                        </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                        <span style="font-weight: normal;">“Reasonable extra cost” shall mean the extra cost of temporary repair and of expediting the repair of such damaged equipment of the insured, including overtime and the extra cost of express or other rapid means of transportation.
                        </span>
                    </li>
                     
                    </ol>
                
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, the following cause of loss is added to Section <b>A.</b> Covered Causes Of Loss of the Causes Of Loss - Basic Form and Causes Of Loss - Broad Form:
                        </p>
                       
                        <p class="font-small" style="font-weight: normal;">
                            "Equipment Breakdown".                        
                        </p>                
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, exclusions <b>2.d.</b> and <b>2.e.</b> from Section <b>B.</b> Exclusions of the Causes Of Loss - Basic Form and exclusions <b>2.b.</b> and <b>2.c.</b> from Section <b>B.</b> Exclusions of the Causes Of Loss - Broad Form are deleted.                        
                        </p>
                    </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top">
            <ol type="A" start="7">
                <li style="font-weight: bold; padding-bottom: 5px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, exclusions <b>2.d.(6)</b> and <b>2.e.</b> are deleted from <b>Section B.</b> Exclusions of the Causes Of Loss – Special Form.                        
                        </p>
                </li>
                <li style="font-weight: bold; padding-bottom: 5px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, item <b>2.a.</b> from Section <b>B.</b> Exclusions of the Causes Of Loss - Basic Form, item <b>2.a.</b> from Section <b>B.</b> Exclusions of the Causes Of Loss - Broad Form and item <b>2.a.</b> from Section <b>B.</b> Exclusions of the Causes Of Loss - Special Form is deleted and replaced with the following:                        
                        </p>
                        <p class="font-small" style="font-weight: normal;">
                            Artificially generated electrical, magnetic or electromagnetic energy that damages, disturbs, disrupts or otherwise interferes with any:                        
                        </p>
                        <ul style="list-style-type: none; padding-left: 0px">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(1) </b>Electrical or electronic wire, device, appliance, system or network; or 
                                    </span>
                                </li>
                                 <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(2) </b>Device, appliance, system or network utilizing cellular or satellite technology. 
                                    </span>
                                </li>
                                <p class="font-small" style="font-weight: normal;">
                                    For the purpose of this exclusion, electrical, magnetic or electromagnetic energy includes but is not limited to:                                        
                                </p>
                        <ul style="list-style-type: none; padding-left: 25px">
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(a) </b>Electrical current, including arcing;
                                    </span>
                                </li>
                                 <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(b) </b>Electrical charge produced or conducted by a magnetic or electromagnetic field; 
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(c) </b>Pulse of electromagnetic energy; or 
                                    </span>
                                </li>
                                <li style="padding-bottom: 10px; font-weight: bold;">
                                    <span style="font-weight: normal;"><b>(d) </b>Electromagnetic waves or microwaves. 
                                    </span>
                                </li>
                        </ul>
                        </ul>
                                     
                        <p class="font-small" style="font-weight: normal;">
                            But if an “equipment breakdown” results, we will pay for the loss or damage caused by that “equipment breakdown”. 
                        </p>
                </li>
                <li style="font-weight: bold; padding-bottom: 5px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, items <b>1.a. </b>and <b>1.b.</b> are deleted from Section <b>C.</b> Limitations of the Causes Of Loss – Special Form.                        
                        </p>                        
                </li>
                <li style="font-weight: bold; padding-bottom: 5px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, under the Causes Of Loss - Special Form the term Covered Cause of Loss includes “equipment breakdown” as defined.                        
                        </p>                        
                </li>
                <li style="font-weight: bold; padding-bottom: 5px;">
                        <p class="font-small" style="font-weight: normal;">
                            With respect to this endorsement only, the following is added to the first Paragraph under definition 2. in Section G. Definitions of the Causes Of Loss - Special Form:                        
                        </p>   
                        <p class="font-small" style="font-weight: normal;">
                            "Specified causes of loss" means the following:                        
                        </p>   
                        <p class="font-small" style="font-weight: normal;">
                            Fire; lightning; explosion; windstorm or hail; smoke; aircraft or vehicles; riot or civil commotion; vandalism; leakage from fire extinguishing equipment; sinkhole collapse; volcanic action; falling objects; weight of snow, ice or sleet; water damage; “equipment breakdown”.                        
                        </p>                      
                </li>
                <li style="list-style-type: none; padding-bottom: 5px;">
                    <p class="font-small" style="font-weight: bold;">
                        All other policy terms and conditions apply.            
                    </p>
                </li>
            </ol>            
          </td>
        </tr>
      </tbody>
    </table>
  </div>  
</div>